export default "__VITE_ASSET__PYJKfwv3__"